module.exports = __webpack_public_path__ + "img/now-playing.cd6061ae.png";